module.exports = __webpack_public_path__ + "static/img_3-1adeda105c0ac121fd971c364e72de90.png";